import type { DialoguePool } from '@/state/types';

export const L12_DIALOGUE: DialoguePool = {
  slowPlay: [
    'It responds to chaos. Like most things worth having.',
    'The button is avoiding you. It\u2019s developed a very sophisticated sense of taste.',
    'You\u2019re just looking at it like a pigeon staring at a calculator.',
  ],
  tokenLoss: [
    'A direct click. Of course. It slipped. Of course.',
    'The button has preferences. You weren\u2019t one of them.',
    'Chased it in a straight line. Touching.',
  ],
  solution: [
    'Triumph! Like finding a sausage in a library. Entirely unexpected.',
    'It slipped. Next level.',
    'You moved absurdly enough. I\u2019ll celebrate by staring at a wall for ten minutes.',
  ],
  spite: ['Still loops, then. Fine. The button missed you.'],
};
